module.exports = __webpack_public_path__ + "img/pds_visual_bgimg.3bc30829.png";